(function(){
    /**
     * @memberof app
     * @ngdoc filter
     * @name ucwords
     * @description
     * capitalize words
     **/
    angular
        .module('app')
        .filter("ucwords", function () {
    		return function (input){
        		if(input) { //when input is defined the apply filter
               
           		input = input.toLowerCase().replace(/^.{1}/g, function(letter) {
              		return letter.toUpperCase();
           		});
        	}
        	return input; 
    	}    
	});
})();